module.exports = "<div class=\"button\" [ngClass]=\"{'small': isSmall, 'logoBtn' : isLogoBtn }\">\r\n    <span class=\"title\" [ngClass]=\"{'small': isSmall, 'logoBtn' : isLogoBtn }\">{{title}}</span>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/buttons/bar-button.component.html
// module id = 2287
// module chunks = 1